<template>
  <b-modal id="modalExplodedBom" ref="modalExplodedBom" :title="title" size="xxl">
    <div class="content">
      <div class="row pb-1 pt-1">
        <div class="col-sm-12 text-right">
          <generic-toggle v-model="ignoreLength" label="Consolidate Material Lengths" @change="fullRefresh()" size-class="btn-sm" />
          <generic-toggle v-model="showInlineDetails" label="Show Inline Details" @change="refreshItems()" size-class="btn-sm" />
          <generic-toggle v-model="consolidateSetupForLabor" label="Consolidate Setup by Catalogue # for Labor" @change="refreshItemsAndRecalculate()" size-class="btn-sm" />
          <generic-toggle v-model="reverseLaborCategories" label="Reverse Categories for Labor" @change="refreshItemsAndRecalculate()" size-class="btn-sm" />
        </div>
      </div>      
      <b-card no-body>
        <b-tabs>
          <b-tab title="Exploded BOM">     
            <div class="row">
              <div class="col-sm-12 mt-2">
                <generic-table ref="explodedBomTable" :items="explodedBomMassaged" :export-key="explodedExportKey" :fields="calculatedExplodedFields" hide-search-reset-buttons
                  :per-page="pageSize" :total-rows="explodedTotalRows" :current-page.sync="explodedPage" toolbar-button-size="sm">
                  <template v-slot:toolbar-buttons>
                    <b-button-group class="mx-1 mb-1 mb-md-0">
                      <b-btn size="sm" variant="primary" @click="explodedBomExport()">Export to CSV</b-btn>
                    </b-button-group>
                  </template>
                  <template v-slot:row-details="row">
                    <b-card no-body v-if="row.item.MATERIAL_NUMBER_PM" class="pb-1 pt-1 px-1">
                      <div class="row">
                        <div class="col-sm-2">
                          <div class="row">
                            <label class="col-sm-4 font-weight-bold">Mat. #</label>
                            <label class="col-sm-8">
                              {{ row.item.MATERIAL_NUMBER_PM }}
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="row">
                            <label class="col-sm-12">
                              {{ row.item.MATERIAL_DESCRIPTION_PM }}
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="row">
                            <label class="col-sm-4 font-weight-bold">Cost</label>
                            <label class="col-sm-8">{{ formatCurrencyExtreme(row.item.MATERIAL_UNIT_COST_PM) }} / {{ row.item.MATERIAL_UOM_PM }}</label>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="row">
                            <label class="col-sm-4 font-weight-bold">Weight</label>
                            <label class="col-sm-8">{{ formatPreciseFloat(row.item.UNIT_WEIGHT_PM) }} per Inch</label>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="row">
                            <label class="col-sm-4 font-weight-bold">Width</label>
                            <label class="col-sm-8">{{ formatPreciseFloat(row.item.WIDTH_PM) }}</label>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </template>
                  <template v-slot:cell(BOM_LEVEL_CALC)="data">
                    <span v-html="formatExplodedLevel(data.item.BOM_LEVEL_CALC)"></span>
                  </template>
                  <template v-slot:cell(DRAWING_NUMBER_CALC)="data">
                    <a v-if="state.enableDrawingLinkFlag && data.item.DRAWING_NUMBER_CALC && data.item.DRAWING_NUMBER_CALC.length" :href="getDrawingFileLink(data.item.DRAWING_NUMBER_CALC)" target="_blank" @click="clickDrawingFileLink(data.item.DRAWING_NUMBER_CALC, $event)">
                      {{ data.item.DRAWING_NUMBER_CALC }}
                    </a>
                    <span v-if="!state.enableDrawingLinkFlag">
                      {{ data.item.DRAWING_NUMBER_CALC }}
                    </span>
                  </template>
                  <template v-slot:foot(EXPLODED_RUN_TIME_CALC)>
                    {{ explodedRunTimeTotal }}
                  </template>
                  <template v-slot:foot(SETUP_TIME_CALC)>
                    {{ explodedSetupTimeTotal }}
                  </template>
                  <!--
                  <template v-slot:foot(MATERIAL_COST_CALC)>
                    {{ explodedMaterialCostTotal }}
                  </template>
                  <template v-slot:foot(LABOR_RUN_CALC)>
                    {{ explodedLaborRunTotal }}
                  </template>
                  <template v-slot:foot(LABOR_SETUP_CALC)>
                    {{ explodedLaborSetupTotal }}
                  </template>
                  -->
                </generic-table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Flattened BOM">
            <div class="row">
              <div class="col-sm-12 mt-2">
                <b-card no-body class="mb-1" v-for="(flattenedCategory) in flattenedCategories" :key="flattenedCategory.category">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    {{ flattenedCategory.category }} : {{ flattenedCategory.bom.length }}
                  </b-card-header>
                  <b-card-body>
                    <generic-table ref="flattenedBomTable" :items="flattenedCategory.bom" :export-key="flattenedExportKey" :fields="calculatedFlattenedFields" hide-search-reset-buttons
                      :per-page="pageSize" :total-rows="flattenedCategory.pagination.totalRows" :current-page.sync="flattenedCategory.pagination.index" toolbar-button-size="sm"
                      :get-export-data-override="flattenedBomGetExportData">
                      <template v-slot:toolbar-buttons>
                        <b-button-group class="mx-1 mb-1 mb-md-0">
                          <b-btn size="sm" variant="primary" @click="flattenedBomExport()">Export to CSV</b-btn>
                        </b-button-group>
                      </template>
                      <template v-slot:cell(DRAWING_NUMBER_CALC)="data">
                        <a v-if="state.enableDrawingLinkFlag && data.item.DRAWING_NUMBER_CALC && data.item.DRAWING_NUMBER_CALC.length" :href="getDrawingFileLink(data.item.DRAWING_NUMBER_CALC)" target="_blank" @click="clickDrawingFileLink(data.item.DRAWING_NUMBER_CALC, $event)">
                          {{ data.item.DRAWING_NUMBER_CALC }}
                        </a>
                        <span v-if="!state.enableDrawingLinkFlag">
                          {{ data.item.DRAWING_NUMBER_CALC }}
                        </span>
                      </template>
                      <template v-slot:foot(QUANTITY_SC)>
                        {{ formatFloat(flattenedCategory.totals.QUANTITY_SC) }}
                      </template>
                      <template v-slot:foot(EXTENDED_TOTAL_CALC)>
                        {{ formatCurrency(flattenedCategory.totals.EXTENDED_TOTAL_CALC) }}
                      </template>
                      <template v-slot:foot(CUSTOM_UNIT_COST_CALC)>
                        {{ formatCurrency(flattenedCategory.totals.AVERAGE_UNIT_COST_TOTAL_CALC) }}
                      </template>
                      <template v-slot:foot(RUN_TIME_CALC)>
                        {{ formatPreciseFloat(flattenedCategory.totals.RUN_TIME_CALC) }}
                      </template>
                      <template v-slot:foot(SETUP_TIME_CALC)>
                        {{ formatFloat(flattenedCategory.totals.SETUP_TIME_CALC) }}
                      </template>
                      <template v-slot:cell(QUANTITY_ORDERED_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/catalogues/catalogue-po-items-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.QUANTITY_ORDERED_CALC) }}
                        </a>
                      </template>
                      <template v-slot:cell(QUANTITY_AVAILABLE_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/mrp-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.QUANTITY_AVAILABLE_CALC) }}
                        </a>
                      </template>
                      <template v-slot:cell(STOCK_AVAILABLE_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/mrp-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.STOCK_AVAILABLE_CALC) }}
                        </a>
                      </template>
                    </generic-table>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </b-tab>
          <b-tab title="Consolidated Mfg">
            <div class="row">
              <div class="col-sm-12 mt-2">
                <b-card no-body class="mb-1" v-for="(manufacturedCategory) in manufacturedCategories" :key="manufacturedCategory.category">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    {{ manufacturedCategory.category }} : {{ manufacturedCategory.bom.length }}
                  </b-card-header>
                  <b-card-body>
                    <generic-table ref="manufacturedBomTable" :items="manufacturedCategory.bom" :export-key="manufacturedExportKey" :fields="calculatedManufacturedFields" hide-search-reset-buttons
                      :per-page="pageSize" :total-rows="manufacturedCategory.pagination.totalRows" :current-page.sync="manufacturedCategory.pagination.index" toolbar-button-size="sm"
                      :get-export-data-override="manufacturedBomGetExportData">
                      <template v-slot:toolbar-buttons>
                        <b-button-group class="mx-1 mb-1 mb-md-0">
                          <b-btn size="sm" variant="primary" @click="manufacturedBomExport()">Export to CSV</b-btn>
                        </b-button-group>
                      </template>
                      <template v-slot:cell(DRAWING_NUMBER_CALC)="data">
                        <a v-if="state.enableDrawingLinkFlag && data.item.DRAWING_NUMBER_CALC && data.item.DRAWING_NUMBER_CALC.length" :href="getDrawingFileLink(data.item.DRAWING_NUMBER_CALC)" target="_blank" @click="clickDrawingFileLink(data.item.DRAWING_NUMBER_CALC, $event)">
                          {{ data.item.DRAWING_NUMBER_CALC }}
                        </a>
                        <span v-if="!state.enableDrawingLinkFlag">
                          {{ data.item.DRAWING_NUMBER_CALC }}
                        </span>
                      </template>
                      <template v-slot:foot(QUANTITY_SC)>
                        {{ formatFloat(manufacturedCategory.totals.QUANTITY_SC) }}
                      </template>
                      <template v-slot:foot(EXTENDED_TOTAL_CALC)>
                        {{ formatCurrency(manufacturedCategory.totals.EXTENDED_TOTAL_CALC) }}
                      </template>
                      <template v-slot:foot(CUSTOM_UNIT_COST_CALC)>
                        {{ formatCurrency(manufacturedCategory.totals.AVERAGE_UNIT_COST_TOTAL_CALC) }}
                      </template>
                      <template v-slot:foot(RUN_TIME_CALC)>
                        {{ formatPreciseFloat(manufacturedCategory.totals.RUN_TIME_CALC) }}
                      </template>
                      <template v-slot:foot(SETUP_TIME_CALC)>
                        {{ formatFloat(manufacturedCategory.totals.SETUP_TIME_CALC) }}
                      </template>
                      <template v-slot:cell(QUANTITY_ORDERED_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/catalogues/catalogue-po-items-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.QUANTITY_ORDERED_CALC) }}
                        </a>
                      </template>
                      <template v-slot:cell(QUANTITY_AVAILABLE_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/mrp-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.QUANTITY_AVAILABLE_CALC) }}
                        </a>
                      </template>
                      <template v-slot:cell(STOCK_AVAILABLE_CALC)="data">
                        <a :href="state.currentTenantId + '/browse/mrp-' + encode(data.item.SUB_PART_CAT_NO_SC)" target="_blank">
                          {{ formatInt(data.item.STOCK_AVAILABLE_CALC) }}
                        </a>
                      </template>
                    </generic-table>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </b-tab>
          <b-tab title="Flattened Labor">
            <div class="row">
              <div class="col-sm-12 mt-2">
                <b-card no-body class="mb-1" v-for="(laborCategory) in laborCategories" :key="laborCategory.category">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    {{ laborCategory.category }} : {{ formatFloat(laborCategory.totals.TOTAL_TIME_CALC) }} hrs : {{ formatCurrency(laborCategory.totals.TOTAL_COST_CALC) }}
                  </b-card-header>
                  <b-card-body>
                    <generic-table ref="laborTable" :items="laborCategory.labor" :export-key="laborExportKey" :fields="calculatedLaborFields" hide-search-reset-buttons
                      :per-page="pageSize" :total-rows="laborCategory.pagination.totalRows" :current-page.sync="laborCategory.pagination.index" toolbar-button-size="sm"
                      :get-export-data-override="laborGetExportData">
                      <template v-slot:toolbar-buttons>
                        <b-button-group class="mx-1 mb-1 mb-md-0">
                          <b-btn size="sm" variant="primary" @click="laborExport()">Export to CSV</b-btn>
                        </b-button-group>
                      </template>
                      <template v-slot:foot(QUANTITY_SC)>
                        {{ formatFloat(laborCategory.totals.QUANTITY_CALC) }}
                      </template>
                      <template v-slot:foot(SETUP_COST_CALC)>
                        {{ formatCurrency(laborCategory.totals.SETUP_COST_CALC) }}
                      </template>
                      <template v-slot:foot(RUN_COST_CALC)>
                        {{ formatCurrency(laborCategory.totals.RUN_COST_CALC) }}
                      </template>
                      <template v-slot:foot(TOTAL_TIME_CALC)>
                        {{ formatFloat(laborCategory.totals.TOTAL_TIME_CALC) }}
                      </template>
                      <template v-slot:foot(TOTAL_COST_CALC)>
                        {{ formatCurrency(laborCategory.totals.TOTAL_COST_CALC) }}
                      </template>
                    </generic-table>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <generic-confirm ref="localFileConfirm" allows-html="true" @shown="localLinkModalShown"></generic-confirm>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: "generic-exploded-bom",
    props: {
      quantityLogic: {
        type: Function,
        required: false
      },
      lengthLogic: {
        type: Function,
        required: false
      },
      additionalFields: {
        type: Array,
        required: false
      }
    },
    created() {

    },
    mounted() {
      this.clear(true);
      this.init();
    },
    watch: {
      'explodedBom': 'calcDerived'
    },
    data() {
      return {
        state: window.appState,
        explodedFields: [
          { key: 'BOM_LEVEL_CALC', label: 'Level', sortable: false, stickyColumn: true },
          { key: 'SUB_PART_CAT_NO_SC', label: 'Catalogue', sortable: false, stickyColumn: true, },
          { key: 'DRAWING_NUMBER_CALC', label: 'Drawing', sortable: true },
          { key: 'ITEM_NUMBER_SC', label: 'Item', sortable: false },
          { key: 'DESCRIPTION_BD', label: 'Description', sortable: false },
          { key: 'TYPE_BD', label: 'Type', sortable: false, isHidden: true },
          { key: 'EXPLODED_QUANTITY_SC', label: 'Quantity', sortable: false, formatter: this.formatFloat, tdClass: 'text-right' },
          { key: 'EXPLODED_LENGTH_SC', label: 'Length', sortable: false, formatter: this.formatPreciseFloat, tdClass: 'text-right' },
          { key: 'EXPLODED_RUN_TIME_CALC', label: 'Run Time', sortable: false, formatter: this.formatPreciseFloat, tdClass: 'text-right' },
          { key: 'SETUP_TIME_CALC', label: 'Setup Time', sortable: false, formatter: this.formatFloat, tdClass: 'text-right' },
          { key: 'EXPLODED_MATERIAL_COST_CALC', label: 'Material $', sortable: false, formatter: this.formatCurrency, tdClass: 'text-right' },
          { key: 'EXPLODED_LABOR_RUN_CALC', label: 'Labor $', sortable: false, formatter: this.formatCurrency, tdClass: 'text-right' },
          { key: 'LABOR_SETUP_CALC', label: 'Setup $', sortable: false, formatter: this.formatCurrency, tdClass: 'text-right' },
          { key: 'SELLING_PRICE_CALC', label: 'Price', sortable: false, formatter: this.formatExplodedSellingPrice, tdClass: 'text-right' },
          { key: 'EXPLODED_CUSTOM_UNIT_COST_CALC', label: 'Unit Cost', sortable: false, formatter: this.formatCurrency, tdClass: 'text-right' },
          { key: 'PSM_CALC', label: 'PSM', sortable: false },
          { key: 'C_P_SC', label: 'C/P', sortable: false },
          { key: 'SHIP_ASSEMBLY_SC', label: 'SA', sortable: false },
          { key: 'VARIABLE_SC', label: 'V', sortable: false },
          { key: 'UOM_CALC', label: 'UM', sortable: false },
          { key: 'QUANTITY_ON_HAND_CALC', label: 'Qty OH', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'QUANTITY_OBLIG_CALC', label: 'Qty Oblig', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'QUANTITY_ORDERED_CALC', label: 'Qty Ord', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'QUANTITY_AVAILABLE_CALC', label: 'Qty Avl', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'STOCK_AVAILABLE_CALC', label: 'Stk Avl', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_NUMBER_PM', label: 'Material #', sortable: false, isHidden: true },
          { key: 'UNIT_WEIGHT_PM', label: 'Mat. Unit Weight', sortable: false, formatter: this.formatFloat, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_UNIT_COST_PM', label: 'Mat. Unit Cost', sortable: false, formatter: this.formatCurrency, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_UOM_PM', label: 'Mat. UOM', sortable: false, isHidden: true },
          { key: 'WIDTH_PM', label: 'Mat. Width', sortable: false, formatter: this.formatPreciseFloat, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_QUANTITY_ON_HAND_CALC', label: 'Mat. Qty OH', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_QUANTITY_OBLIG_CALC', label: 'Mat. Qty Oblig', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_QUANTITY_ORDERED_CALC', label: 'Mat. Qty Ord', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_QUANTITY_AVAILABLE_CALC', label: 'Mat. Qty Avl', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
          { key: 'MATERIAL_STOCK_AVAILABLE_CALC', label: 'Mat. Stk Avl', sortable: false, formatter: this.formatInt, isHidden: true, tdClass: 'text-right' },
        ],
        fullFlattenedFields: [
          { key: 'CATEGORY_BD', label: 'Category', sortable: false, stickyColumn: true, isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'SUB_PART_CAT_NO_SC', label: 'Catalogue', sortable: false, stickyColumn: true, tdClass: this.getFlattenedClass },
          { key: 'DESCRIPTION_BD', label: 'Description', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'TYPE_BD', label: 'Type', sortable: false, isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_SC', label: 'Quantity', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'PIECES_CALC', label: 'Pieces', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'DIMENSION_A_CALC', label: 'Dim', sortable: false, formatter: this.formatFloat, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'DATE_REQUIRED_CALC', label: 'Required', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getFlattenedClass },
          { key: 'LENGTH_SC', label: 'Length', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'UNIT_WEIGHT_PM', label: 'Unit Weight', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'MATERIAL_COST_CALC', label: 'Material $', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'CUSTOM_UNIT_COST_CALC', label: 'Unit Cost', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'UOM_CALC', label: 'UM', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'EXTENDED_TOTAL_CALC', label: 'Ext. Total', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'PSM_CALC', label: 'PSM', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'C_P_SC', label: 'C/P', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'SHIP_ASSEMBLY_SC', label: 'SA', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'VARIABLE_SC', label: 'V', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'MAX_PO_DATE_LPOD', label: 'Last PO', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getFlattenedClass },
          { key: 'PIECES_AVAILABLE_CALC', label: 'P# Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_ORDERED_CALC', label: 'Qty Ord', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_AVAILABLE_CALC', label: 'Qty Avl', sortable: false, formatter: this.formatInt, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'STOCK_AVAILABLE_CALC', label: 'Stk Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'MIN_BOM_LEVEL_CALC', label: 'Min Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'MAX_BOM_LEVEL_CALC', label: 'Max Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
        ],
        consolidatedFlattenedFields: [
          { key: 'CATEGORY_BD', label: 'Category', sortable: false, stickyColumn: true, isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'SUB_PART_CAT_NO_SC', label: 'Catalogue', sortable: false, stickyColumn: true, tdClass: this.getFlattenedClass },
          { key: 'DESCRIPTION_BD', label: 'Description', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'TYPE_BD', label: 'Type', sortable: false, isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_SC', label: 'Quantity', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'PIECES_CALC', label: 'Pieces', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'DIMENSION_A_CALC', label: 'Dim', sortable: false, formatter: this.formatFloat, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'DATE_REQUIRED_CALC', label: 'Required', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getFlattenedClass },
          { key: 'LENGTH_SC', label: 'Length', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'UNIT_WEIGHT_PM', label: 'Unit Weight', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'MATERIAL_COST_CALC', label: 'Material $', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'CUSTOM_UNIT_COST_CALC', label: 'Unit Cost', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'UOM_CALC', label: 'UM', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'EXTENDED_TOTAL_CALC', label: 'Ext. Total', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'PSM_CALC', label: 'PSM', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'C_P_SC', label: 'C/P', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'SHIP_ASSEMBLY_SC', label: 'SA', sortable: false, tdClass: this.getFlattenedClass },
          { key: 'MAX_PO_DATE_LPOD', label: 'Last PO', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getFlattenedClass },
          { key: 'PIECES_AVAILABLE_CALC', label: 'P# Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_ORDERED_CALC', label: 'Qty Ord', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'QUANTITY_AVAILABLE_CALC', label: 'Qty Avl', sortable: false, formatter: this.formatInt, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'STOCK_AVAILABLE_CALC', label: 'Stk Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getFlattenedClass },
          { key: 'MIN_BOM_LEVEL_CALC', label: 'Min Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
          { key: 'MAX_BOM_LEVEL_CALC', label: 'Max Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getFlattenedClass },
        ],
        manufacturedFields: [
          { key: 'CATEGORY_BD', label: 'Category', sortable: false, stickyColumn: true, isHidden: true, tdClass: this.getManufacturedClass },
          { key: 'SUB_PART_CAT_NO_SC', label: 'Catalogue', sortable: false, stickyColumn: true, tdClass: this.getManufacturedClass },
          { key: 'DESCRIPTION_BD', label: 'Description', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'TYPE_BD', label: 'Type', sortable: false, isHidden: true, tdClass: this.getManufacturedClass },
          { key: 'QUANTITY_SC', label: 'Quantity', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'PIECES_CALC', label: 'Pieces', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'DIMENSION_A_CALC', label: 'Dim', sortable: false, formatter: this.formatFloat, class: 'text-right', isHidden: true, tdClass: this.getManufacturedClass },
          { key: 'DATE_REQUIRED_CALC', label: 'Required', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getManufacturedClass },
          { key: 'LENGTH_SC', label: 'Length', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'UNIT_WEIGHT_PM', label: 'Unit Weight', sortable: false, formatter: this.formatFloat, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'MATERIAL_COST_CALC', label: 'Material $', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'CUSTOM_UNIT_COST_CALC', label: 'Unit Cost', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'UOM_CALC', label: 'UM', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'EXTENDED_TOTAL_CALC', label: 'Ext. Total', sortable: false, formatter: this.formatCurrency, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'PSM_CALC', label: 'PSM', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'C_P_SC', label: 'C/P', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'SHIP_ASSEMBLY_SC', label: 'SA', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'VARIABLE_SC', label: 'V', sortable: false, tdClass: this.getManufacturedClass },
          { key: 'MAX_PO_DATE_LPOD', label: 'Last PO', sortable: false, formatter: this.formatDateSansTime, tdClass: this.getManufacturedClass },
          { key: 'PIECES_AVAILABLE_CALC', label: 'P# Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'QUANTITY_ORDERED_CALC', label: 'Qty Ord', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'QUANTITY_AVAILABLE_CALC', label: 'Qty Avl', sortable: false, formatter: this.formatInt, class: 'text-right', isHidden: true, tdClass: this.getManufacturedClass },
          { key: 'STOCK_AVAILABLE_CALC', label: 'Stk Avl', sortable: false, formatter: this.formatInt, class: 'text-right', tdClass: this.getManufacturedClass },
          { key: 'MIN_BOM_LEVEL_CALC', label: 'Min Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getManufacturedClass },
          { key: 'MAX_BOM_LEVEL_CALC', label: 'Max Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true, tdClass: this.getManufacturedClass },
        ],
        laborFields: [
          { key: 'CATEGORY_WM', label: 'Category', sortable: false, stickyColumn: true, isHidden: true },
          { key: 'WORK_CENTER_OF', label: 'Work Center', sortable: false, stickyColumn: true },
          { key: 'WKCT_DESCRIPTION_WM', label: 'Description', sortable: false },
          { key: 'QUANTITY_CALC', label: 'Quantity', sortable: false, formatter: this.formatFloat, class: 'text-right', isHidden: true },
          { key: 'SETUP_TIME_OF', label: 'Setup Hrs', sortable: false, formatter: this.formatFloat, class: 'text-right' },
          { key: 'RUN_TIME_OF', label: 'Run Hrs', sortable: false, formatter: this.formatPreciseFloat, class: 'text-right' },
          { key: 'ESTIMATE_RATE_WM', label: 'Hrly Rate', sortabel: false, formatter: this.formatCurrency, class: 'text-right' },
          { key: 'SETUP_COST_CALC', label: 'Setup $', sortable: false, formatter: this.formatCurrency, class: 'text-right' },
          { key: 'RUN_COST_CALC', label: 'Run $', sortable: false, formatter: this.formatCurrency, class: 'text-right' },
          { key: 'TOTAL_TIME_CALC', label: 'Total Hrs', sortable: false, formatter: this.formatFloat, class: 'text-right' },
          { key: 'TOTAL_COST_CALC', label: 'Total $', sortable: false, formatter: this.formatCurrency, class: 'text-right' },
          { key: 'MIN_BOM_LEVEL_CALC', label: 'Min Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true },
          { key: 'MAX_BOM_LEVEL_CALC', label: 'Max Lvl', sortable: false, stickyColumn: true, class: 'text-right', isHidden: true },
          { key: 'SETUP_COUNTER', label: 'Setup Ctr', sortable: false, formatter: this.formatInt, class: 'text-right', isHidden: true },
          { key: 'RUN_COUNTER', label: 'Run Ctr', sortable: false, formatter: this.formatInt, class: 'text-right', isHidden: true },
        ],
        explodedTotals: {
          EXPLODED_RUN_TIME_CALC: 0.00,
          SETUP_TIME_CALC: 0.00,
          EXPLODED_MATERIAL_COST_CALC: 0.00,
          EXPLODED_LABOR_RUN_CALC: 0.00,
          LABOR_SETUP_CALC: 0.00,
          SELLING_PRICE_CALC: 0.00,
          EXPLODED_CUSTOM_UNIT_COST_TOTAL_CALC: 0.00
        },
        pageSize: (window.appState.preferences.defaultPageSize || 10),
        explodedTotalRows: 0,
        explodedIndex: 1,
        explodedPage: 1,
        isBusy: false,
        messages: [ ],
        title: '',
        explodedBom: [ ],
        flattenedBom: [ ],
        flattenedCategories: [ ],
        manufacturedBom: [ ],
        manufacturedCategories: [ ],
        labor: [ ],
        laborCategories: [ ],
        exportKeySegment: null,
        showInlineDetails: true,
        consolidateSetupForLabor: false,
        ignoreLength: false,
        reverseLaborCategories: (window.appState.currentTenantId === 2),
        cachedParameters: {
          quoteNumber: null,
          proposalNumber: null,
          type: null,
        }
      };
    },
    computed: {
      explodedExportKey() {
        return `${this.exportKeySegment || 'generic'}-exploded-bom-list`;  
      },
      explodedBomMassaged() {
        let explodedBomMassaged = [];
        this.explodedBom.forEach((eb) => {
          let ebm = Object.assign({}, eb);
          ebm._showDetails = this.showInlineDetails;
          explodedBomMassaged.push(ebm);
        })
        return explodedBomMassaged;
      },
      flattenedExportKey() {
        return `${this.exportKeySegment || 'generic'}-flattened-bom-list`;  
      },
      manufacturedExportKey() {
        return `${this.exportKeySegment || 'generic'}-manufactured-bom-list`;  
      },
      laborExportKey() {
        return `${this.exportKeySegment || 'generic'}-flattened-labor-list`;  
      },
      explodedRunTimeTotal() {
        return this.formatPreciseFloat(
          (this.explodedTotals.EXPLODED_RUN_TIME_CALC || 0.00)
        );
      },
      explodedSetupTimeTotal() {
        return this.formatFloat(
          (this.explodedTotals.SETUP_TIME_CALC || 0.00)
        );
      },
      explodedMaterialCostTotal() {
        return this.formatCurrency(
          (this.explodedTotals.EXPLODED_MATERIAL_COST_CALC || 0.00)
        );
      },
      explodedLaborRunTotal() {
        return this.formatCurrency(
          (this.explodedTotals.EXPLODED_LABOR_RUN_CALC || 0.00)
        );
      },
      explodedLaborSetupTotal() {
        return this.formatCurrency(
          (this.explodedTotals.LABOR_SETUP_CALC || 0.00)
        );
      },
      explodedSellingPriceTotal() {
        return this.formatCurrency(
          (this.explodedTotals.SELLING_PRICE_CALC || 0.00)
        );
      },
      calculatedExplodedFields() {
        let calculatedFields = this.additionalFields || [];
        this.explodedFields.forEach((field) => {
          calculatedFields.push(field);
        });
        return calculatedFields;
      },
      calculatedFlattenedFields() {
        let calculatedFields = [];
        let flattenedFields = this.ignoreLength ? this.consolidatedFlattenedFields : this.fullFlattenedFields;
        flattenedFields.forEach((field) => {
          calculatedFields.push(field);
        });
        return calculatedFields;
      },
      calculatedManufacturedFields() {
        let calculatedFields = [];
        this.manufacturedFields.forEach((field) => {
          calculatedFields.push(field);
        });
        return calculatedFields;
      },
      calculatedLaborFields() {
        let calculatedFields = [];
        this.laborFields.forEach((field) => {
          calculatedFields.push(field);
        });
        return calculatedFields;
      },
    },
    methods: {
      encode: appHelpers.url.encode,
      formatDate: appHelpers.formatters.formatDate,
      formatDateSansTime: appHelpers.formatters.formatDateSansTime,
      formatCurrency: appHelpers.formatters.formatCurrency,
      formatCurrencyInt: appHelpers.formatters.formatCurrencyInt,
      formatCurrencyExtreme: appHelpers.formatters.formatCurrencyExtreme,
      formatInt: appHelpers.formatters.formatInt,
      formatFloat: appHelpers.formatters.formatFloat,
      formatPreciseFloat: appHelpers.formatters.formatPreciseFloat,
      formatBool: appHelpers.formatters.formatBool,
      formatExplodedLevel(value, key, item) {
        let stringValue = value.toString();
        for (let ptr = 1; ptr < value; ptr++) {
          stringValue = "&nbsp;" + stringValue;
        }
        return stringValue;
      },
      formatExplodedOperation(value, key, item) {
        if (value) {
          return this.formatInt(value);
        }
        return null;
      },
      formatExplodedSellingPrice(value, key, item) {
        return this.formatCurrency(
          (item.SELLING_PRICE_CALC || 0.00)
        );
      },
      getFlattenedClass(value, key, item) {
        let classes = [ ];
        if (item.MAX_PO_DATE_LPOD) {
          let lastPODate = dayjs(item.MAX_PO_DATE_LPOD);
          let daysOld = (dayjs().diff(lastPODate, 'days', true));
          if (daysOld > 30) {
            classes.push('table-warning');
          }
        } else {
          classes.push('table-warning');
        }
        return classes;
      },
      getManufacturedClass(value, key, item) {
        let classes = [ ];
        return classes;
      },
      init() {
      },
      calcDerived() {
        this.calcFlattened();
        this.calcManufactured();
        this.calcLabor();
        this.calcTotals();
      },
      calcFlattened() {
        //Calculate Flattened BOM
        let flattenedCategories = { };

        this.flattenedBom.forEach((fb) => {
          let catKey = fb.CATEGORY_BD;
          if (!flattenedCategories[catKey]) {
            flattenedCategories[catKey] = {
              category: catKey,
              pagination: {
                totalRows: 0,
                index: 1,
              },
              totals: {
                RUN_TIME_CALC: 0.00,
                SETUP_TIME_CALC: 0.00,
                MATERIAL_COST_CALC: 0.00,
                LABOR_RUN_CALC: 0.00,
                LABOR_SETUP_CALC: 0.00,
                SELLING_PRICE_CALC: 0.00,
                AVERAGE_UNIT_COST_TOTAL_CALC: 0.00,
                QUANTITY_SC: 0.00,
                EXTENDED_TOTAL_CALC: 0.00,
                PIECES_CALC: 0.00,
              },
              bom: [ ]
            };
          }
          let flatCat = flattenedCategories[catKey];
          flatCat.bom.push(fb);
        });

        this.flattenedCategories = [ ];
        let catKeys = Object.keys(flattenedCategories).sort();
        for (let catIndex in catKeys) {
          let catKey = catKeys[catIndex];
          let flatCat = flattenedCategories[catKey];
          this.flattenedCategories.push(flatCat);
        }
      },
      calcManufactured() {
        //Calculate manufactured BOM
        let manufacturedCategories = { };

        this.manufacturedBom.forEach((fb) => {
          let catKey = fb.CATEGORY_BD;
          if (!manufacturedCategories[catKey]) {
            manufacturedCategories[catKey] = {
              category: catKey,
              pagination: {
                totalRows: 0,
                index: 1,
              },
              totals: {
                RUN_TIME_CALC: 0.00,
                SETUP_TIME_CALC: 0.00,
                MATERIAL_COST_CALC: 0.00,
                LABOR_RUN_CALC: 0.00,
                LABOR_SETUP_CALC: 0.00,
                SELLING_PRICE_CALC: 0.00,
                AVERAGE_UNIT_COST_TOTAL_CALC: 0.00,
                QUANTITY_SC: 0.00,
                EXTENDED_TOTAL_CALC: 0.00,
                PIECES_CALC: 0.00,
              },
              bom: [ ]
            };
          }
          let manuCat = manufacturedCategories[catKey];
          manuCat.bom.push(fb);
        });

        this.manufacturedCategories = [ ];
        let catKeys = Object.keys(manufacturedCategories).sort();
        for (let catIndex in catKeys) {
          let catKey = catKeys[catIndex];
          let manuCat = manufacturedCategories[catKey];
          this.manufacturedCategories.push(manuCat);
        }
      },
      calcLabor() {
        //Calculate Labor
        let laborCategories = { };

        this.explodedBom.forEach((fb) => {
          if (((fb.TYPE_BD || '') !== 'C') || ((fb.PSM_CALC || '') !== 'S')) {
            let quantity = (this.calcQuantity(fb) || 1.00) * (fb.QUANTITY_SC || 0.00);
            if (fb.operations && fb.operations.length) {
              fb.operations.forEach((fbOp) => {
                let catKey = fbOp.CATEGORY_WM;
                let wcKey = fbOp.WORK_CENTER_OF;
                if (!laborCategories[catKey]) {
                  laborCategories[catKey] = {
                    category: catKey,
                    pagination: {
                      totalRows: 0,
                      index: 1,
                    },
                    totals: {
                      RUN_TIME_OF: 0.00,
                      SETUP_TIME_OF: 0.00,
                      SETUP_COST_CALC: 0.00,
                      RUN_COST_CALC: 0.00,
                      TOTAL_TIME_CALC: 0.00,
                      TOTAL_COST_CALC: 0.00,
                      QUANTITY_CALC: 0.00,
                    },
                    workcenters: { },
                    labor: [ ]
                  };
                }
                let laborCat = laborCategories[catKey];
                if (!laborCat.workcenters[wcKey]) {
                  laborCat.workcenters[wcKey] = Object.assign({}, fbOp);
                  laborCat.workcenters[wcKey]._showDetails = this.showInlineDetails;
                  laborCat.workcenters[wcKey].QUANTITY_CALC = 0.00;
                  laborCat.workcenters[wcKey].SETUP_COUNTER = 0.00;
                  laborCat.workcenters[wcKey].SETUP_TIME_OF = 0.00;
                  laborCat.workcenters[wcKey].RUN_COUNTER = 0.00;
                  laborCat.workcenters[wcKey].RUN_TIME_OF = 0.00;
                  laborCat.workcenters[wcKey].SETUP_COST_CALC = 0.00;
                  laborCat.workcenters[wcKey].RUN_COST_CALC = 0.00;
                  laborCat.workcenters[wcKey].TOTAL_TIME_CALC = 0.00;
                  laborCat.workcenters[wcKey].TOTAL_COST_CALC = 0.00;
                  laborCat.workcenters[wcKey].MIN_BOM_LEVEL_CALC = null;
                  laborCat.workcenters[wcKey].MAX_BOM_LEVEL_CALC = null;
                  laborCat.workcenters[wcKey].catalogues = { };
                }
                if (laborCat.workcenters[wcKey].MIN_BOM_LEVEL_CALC === null || laborCat.workcenters[wcKey].MIN_BOM_LEVEL_CALC > fb.BOM_LEVEL_CALC) {
                  laborCat.workcenters[wcKey].MIN_BOM_LEVEL_CALC = fb.BOM_LEVEL_CALC;
                }
                if (laborCat.workcenters[wcKey].MAX_BOM_LEVEL_CALC === null || laborCat.workcenters[wcKey].MAX_BOM_LEVEL_CALC < fb.BOM_LEVEL_CALC) {
                  laborCat.workcenters[wcKey].MAX_BOM_LEVEL_CALC = fb.BOM_LEVEL_CALC;
                }
                let setupTime = (fbOp.SETUP_TIME_OF || 0.00);
                let runTime = (this.calcQuantity(fb) || 1.00) * (fb.QUANTITY_SC || 0.00) * (fbOp.RUN_TIME_OF || 0.00);
                laborCat.workcenters[wcKey].QUANTITY_CALC += quantity;
                laborCat.workcenters[wcKey].RUN_TIME_OF += runTime;
                laborCat.workcenters[wcKey].RUN_COST_CALC += runTime * (fbOp.ESTIMATE_RATE_WM || 0.00);
                laborCat.workcenters[wcKey].RUN_COUNTER++;

                if (!this.consolidateSetupForLabor || !laborCat.workcenters[wcKey].catalogues[fbOp.CATALOGUE_NUMBER_OF]) {
                  laborCat.workcenters[wcKey].catalogues[fbOp.CATALOGUE_NUMBER_OF] = true;
                  
                  laborCat.workcenters[wcKey].SETUP_TIME_OF += setupTime;
                  laborCat.workcenters[wcKey].SETUP_COST_CALC += setupTime * (fbOp.ESTIMATE_RATE_WM || 0.00);
                  laborCat.workcenters[wcKey].SETUP_COUNTER++;

                  laborCat.workcenters[wcKey].TOTAL_TIME_CALC += (setupTime + runTime);
                  laborCat.workcenters[wcKey].TOTAL_COST_CALC += (setupTime + runTime) * (fbOp.ESTIMATE_RATE_WM || 0.00);
                } else {
                  laborCat.workcenters[wcKey].TOTAL_TIME_CALC += (runTime);
                  laborCat.workcenters[wcKey].TOTAL_COST_CALC += (runTime) * (fbOp.ESTIMATE_RATE_WM || 0.00);
                }
              });
            }
          }
        });

        this.laborCategories = [ ];
        this.labor = [ ];
        
        let catKeys = Object.keys(laborCategories).sort();
        if (this.reverseLaborCategories) {
          catKeys = catKeys.reverse();
        }
        for (let catIndex in catKeys) {
          let catKey = catKeys[catIndex];
          let laborCat = laborCategories[catKey];
          let wcKeys = Object.keys(laborCat.workcenters).sort();
          laborCat.labor = [ ];
          for (let wcIndex in wcKeys) {
            let wcKey = wcKeys[wcIndex];
            laborCat.labor.push(laborCat.workcenters[wcKey]);
            this.labor.push(laborCat.workcenters[wcKey]);
          }
          this.laborCategories.push(laborCat);
        }
      },
      calcTotals() {
        this.explodedTotalRows = this.explodedBom ? this.explodedBom.length : 0;

        this.explodedTotals.EXPLODED_RUN_TIME_CALC = 0.00;
        this.explodedTotals.SETUP_TIME_CALC = 0.00;
        this.explodedTotals.EXPLODED_MATERIAL_COST_CALC = 0.00;
        this.explodedTotals.EXPLODED_LABOR_RUN_CALC = 0.00;
        this.explodedTotals.LABOR_SETUP_CALC = 0.00;
        this.explodedTotals.SELLING_PRICE_CALC = 0.00;
        this.explodedTotals.EXPLODED_CUSTOM_UNIT_COST_TOTAL_CALC = 0.00;

        this.explodedBom.forEach((fb) => {
          this.explodedTotals.EXPLODED_RUN_TIME_CALC += (fb.EXPLODED_RUN_TIME_CALC || 0.00);
          this.explodedTotals.SETUP_TIME_CALC += (fb.SETUP_TIME_CALC || 0.00);
          this.explodedTotals.EXPLODED_MATERIAL_COST_CALC += (fb.EXPLODED_MATERIAL_COST_CALC || 0.00);
          this.explodedTotals.EXPLODED_LABOR_RUN_CALC += (fb.EXPLODED_LABOR_RUN_CALC || 0.00);
          this.explodedTotals.LABOR_SETUP_CALC += (fb.LABOR_SETUP_CALC || 0.00);
          this.explodedTotals.SELLING_PRICE_CALC += (this.calcQuantity(fb) || 1.00) * (fb.QUANTITY_SC || 0.00) * (fb.SELLING_PRICE_CALC || 0.00);
          this.explodedTotals.EXPLODED_CUSTOM_UNIT_COST_TOTAL_CALC += (fb.EXPLODED_CUSTOM_UNIT_COST_TOTAL_CALC || 0.00);
        });

        let catKeys = Object.keys(this.flattenedCategories).sort();
        for (let catIndex in catKeys) {
          let catKey = catKeys[catIndex];
          let flatCat = this.flattenedCategories[catKey];

          flatCat.pagination.totalRows = flatCat.bom ? flatCat.bom.length : 0;
          flatCat.pagination.index = 1;

          flatCat.totals.RUN_TIME_CALC = 0.00;
          flatCat.totals.SETUP_TIME_CALC = 0.00;
          flatCat.totals.MATERIAL_COST_CALC = 0.00;
          flatCat.totals.LABOR_RUN_CALC = 0.00;
          flatCat.totals.LABOR_SETUP_CALC = 0.00;
          flatCat.totals.SELLING_PRICE_CALC = 0.00;
          flatCat.totals.AVERAGE_UNIT_COST_TOTAL_CALC = 0.00;
          flatCat.totals.QUANTITY_SC = 0.00;
          flatCat.totals.EXTENDED_TOTAL_CALC = 0.00;

          flatCat.bom.forEach((fb) => {
            flatCat.totals.RUN_TIME_CALC += (fb.RUN_TIME_CALC || 0.00);
            flatCat.totals.SETUP_TIME_CALC += (fb.SETUP_TIME_CALC || 0.00);
            flatCat.totals.MATERIAL_COST_CALC += (fb.MATERIAL_COST_CALC || 0.00);
            flatCat.totals.LABOR_RUN_CALC += ((fb.LABOR_TOTAL_CALC || 0.00) - (fb.LABOR_SETUP_CALC || 0.00));
            flatCat.totals.LABOR_SETUP_CALC += (fb.LABOR_SETUP_CALC || 0.00);
            flatCat.totals.SELLING_PRICE_CALC += (fb.SELLING_PRICE_CALC || 0.00);
            flatCat.totals.CUSTOM_UNIT_COST_TOTAL_CALC += (fb.CUSTOM_UNIT_COST_TOTAL_CALC || 0.00);
            flatCat.totals.QUANTITY_SC += (fb.QUANTITY_SC || 0.00);
            flatCat.totals.EXTENDED_TOTAL_CALC += (fb.EXTENDED_TOTAL_CALC || 0.00);
          });
          if (flatCat.totals.QUANTITY_SC != 0) {
            flatCat.totals.AVERAGE_UNIT_COST_TOTAL_CALC = flatCat.totals.EXTENDED_TOTAL_CALC / flatCat.totals.QUANTITY_SC;
          }
        }

        let manuCatKeys = Object.keys(this.manufacturedCategories).sort();
        for (let manuCatIndex in manuCatKeys) {
          let manuCatKey = manuCatKeys[manuCatIndex];
          let manuCat = this.manufacturedCategories[manuCatKey];

          manuCat.pagination.totalRows = manuCat.bom ? manuCat.bom.length : 0;
          manuCat.pagination.index = 1;

          manuCat.totals.RUN_TIME_CALC = 0.00;
          manuCat.totals.SETUP_TIME_CALC = 0.00;
          manuCat.totals.MATERIAL_COST_CALC = 0.00;
          manuCat.totals.LABOR_RUN_CALC = 0.00;
          manuCat.totals.LABOR_SETUP_CALC = 0.00;
          manuCat.totals.SELLING_PRICE_CALC = 0.00;
          manuCat.totals.AVERAGE_UNIT_COST_TOTAL_CALC = 0.00;
          manuCat.totals.QUANTITY_SC = 0.00;
          manuCat.totals.EXTENDED_TOTAL_CALC = 0.00;

          manuCat.bom.forEach((fb) => {
            manuCat.totals.RUN_TIME_CALC += (fb.RUN_TIME_CALC || 0.00);
            manuCat.totals.SETUP_TIME_CALC += (fb.SETUP_TIME_CALC || 0.00);
            manuCat.totals.MATERIAL_COST_CALC += (fb.MATERIAL_COST_CALC || 0.00);
            manuCat.totals.LABOR_RUN_CALC += ((fb.LABOR_TOTAL_CALC || 0.00) - (fb.LABOR_SETUP_CALC || 0.00));
            manuCat.totals.LABOR_SETUP_CALC += (fb.LABOR_SETUP_CALC || 0.00);
            manuCat.totals.SELLING_PRICE_CALC += (fb.SELLING_PRICE_CALC || 0.00);
            manuCat.totals.CUSTOM_UNIT_COST_TOTAL_CALC += (fb.CUSTOM_UNIT_COST_TOTAL_CALC || 0.00);
            manuCat.totals.QUANTITY_SC += (fb.QUANTITY_SC || 0.00);
            manuCat.totals.EXTENDED_TOTAL_CALC += (fb.EXTENDED_TOTAL_CALC || 0.00);
          });
          if (manuCat.totals.QUANTITY_SC != 0) {
            manuCat.totals.AVERAGE_UNIT_COST_TOTAL_CALC = manuCat.totals.EXTENDED_TOTAL_CALC / manuCat.totals.QUANTITY_SC;
          }
        }

        let labCatKeys = Object.keys(this.laborCategories).sort();
        for (let labCatIndex in labCatKeys) {
          let labCatKey = labCatKeys[labCatIndex];
          let labCat = this.laborCategories[labCatKey];

          labCat.pagination.totalRows = labCat.workcenters ? labCat.workcenters.length : 0;
          labCat.pagination.index = 1;

          labCat.totals.QUANTITY_CALC = 0.00;
          labCat.totals.RUN_TIME_OF = 0.00;
          labCat.totals.SETUP_TIME_OF = 0.00;
          labCat.totals.SETUP_COST_CALC = 0.00;
          labCat.totals.RUN_COST_CALC = 0.00;
          labCat.totals.TOTAL_TIME_CALC = 0.00;
          labCat.totals.TOTAL_COST_CALC = 0.00;

          labCat.labor.forEach((lab) => {
            labCat.totals.QUANTITY_CALC += (lab.QUANTITY_CALC || 0.00);
            labCat.totals.RUN_TIME_OF += (lab.RUN_TIME_OF || 0.00);
            labCat.totals.SETUP_TIME_OF += (lab.SETUP_TIME_OF || 0.00);
            labCat.totals.RUN_COST_CALC += (lab.RUN_COST_CALC || 0.00);
            labCat.totals.SETUP_COST_CALC += (lab.SETUP_COST_CALC || 0.00);
            labCat.totals.TOTAL_TIME_CALC += (lab.TOTAL_TIME_CALC || 0.00);
            labCat.totals.TOTAL_COST_CALC += (lab.TOTAL_COST_CALC || 0.00);
          });
        }
      },
      calcQuantity(fb) {
        return this.quantityLogic ? this.quantityLogic(fb) : 1.00;
      },
      calcLength(fb) {
        return this.lengthLogic ? this.lengthLogic(fb) : (fb.LENGTH_SC || 0.00); 
      },
      clear(preInitFlag) {
        this.totals = {
          RUN_TIME_CALC: 0.00,
          SETUP_TIME_CALC: 0.00,
          MATERIAL_COST_CALC: 0.00,
          LABOR_RUN_CALC: 0.00,
          LABOR_SETUP_CALC: 0.00,
          SELLING_PRICE_CALC: 0.00,
          CUSTOM_UNIT_COST_CALC: 0.00,
        };
      },
      explodedBomExport() {
        this.$refs.explodedBomTable.exportData();
      },
      flattenedBomExport() {
        this.$refs.flattenedBomTable[0].exportData();
      },
      manufacturedBomExport() {
        this.$refs.manufacturedBomTable[0].exportData();
      },
      laborExport() {
        this.$refs.laborTable[0].exportData();
      },
      flattenedBomGetExportData() {
        return Promise.resolve(this.flattenedBom);
      },
      manufacturedBomGetExportData() {
        return Promise.resolve(this.manufacturedBom);
      },
      laborGetExportData() {
        return Promise.resolve(this.labor);
      },
      getDrawingFileLink(drawingNumber) {
        return appHelpers.drawings.getLink(drawingNumber);
      },
      clickDrawingFileLink(drawingNumber, event) {
        var isLocalLink = (this.state.drawingLinkPathStructure && this.state.drawingLinkPathStructure.toLowerCase().indexOf('file:') == 0);
        var isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        var isEdge = navigator.userAgent.toLowerCase().indexOf('edge/') > -1;
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        if (isLocalLink && !isIE) {
          var drawingFileLink = this.getDrawingFileLink(drawingNumber);
          var node = document.createElement("span");
          node.appendChild(document.createTextNode(drawingFileLink));
          document.body.appendChild(node);
          var range = document.createRange();
          var selection = window.getSelection();
          selection.removeAllRanges();
          range.selectNodeContents(node);
          selection.addRange(range);
          document.execCommand('copy');
          selection.removeAllRanges();
          node.remove();
          event.preventDefault();
          var message = isEdge ? 'Your browser cannot open this link under any circumstances. Upgrade to a reputable browser please!' : 'Please paste this URL into a new browser tab (it should already have been copied into the clipboard):';
          this.$refs.localFileConfirm.confirm(`<p>${message}</p><p><input id="txtLocalPath" class="form-control" type="text" value="${drawingFileLink}"></p>`, { 
            okOnly: true, title: 'Your browser cannot open this link automatically'
          }, true).finally(() => {
            //Catch-all
          });
          return;
        }
      },
      localLinkModalShown() {
        let txtLocalPath = document.getElementById('txtLocalPath');
        txtLocalPath.select();
      },
      refreshItems() {
        if (this.$refs.explodedBomTable) {
          this.$refs.explodedBomTable.refreshTable();
        }
        if (this.$refs.flattenedBomTable && this.$refs.flattenedBomTable.length) {
          this.$refs.flattenedBomTable.forEach((fbt) => {
            fbt.refreshTable();
          });
        }
      },
      refreshItemsAndRecalculate() {
        this.calcDerived();
        this.refreshItems();
      },
      fullRefresh() {
        switch (this.cachedParameters.type || '') {
          case 'CableTrayQuote':
            this.showExplodedBomForCableTrayQuote();
            break;
          case 'Proposal':
            this.showExplodedBomForProposal();
            break;
          case 'CableBusQuote':
            this.showExplodedBomForCableBusQuote();
            break;
        }
      },
      showExplodedBomPre() {
        this.flattenedBom = [ ];
        this.flattenedCategories = [ ];

        this.manufacturedBom = [ ];
        this.manufacturedCategories =  [ ];

        this.labor = [ ];
        this.laborCategories = [ ];

        this.explodedBom = [ ];
        this.explodedTotalRows = 0;

        this.$emit('alert', null, true);
      },
      showExplodedBomPost(response, exportKeySegment, title) {
        appHelpers.audit.logEntityAction('Exploded BOM for', appHelpers.text.replace(title, 'Exploded BOM for ', ''));
        this.exportKeySegment = exportKeySegment;
        this.title = title;
        this.flattenedBom = response.body.flat;
        this.manufacturedBom = response.body.manu;
        this.explodedBom = response.body.full;
        this.$refs.modalExplodedBom.show();
      },
      showExplodedBomForProposal(proposalNumber, exportKeySegment, title) {
        proposalNumber = proposalNumber || this.cachedParameters.proposalNumber;
        exportKeySegment = exportKeySegment || this.exportKeySegment;
        title = title || this.title;

        this.showExplodedBomPre();

        appHelpers.loader.start();
        apiClient.host.proposal.listFullBOM(this.state.currentTenantId, proposalNumber, 10, null, this.ignoreLength).then((response) => {
          this.cachedParameters.proposalNumber = proposalNumber;
          this.cachedParameters.type = 'Proposal';
          this.showExplodedBomPost(response, exportKeySegment, title);
        }).catch(error => {
          let messages = appHelpers.message.getFromResponse(error);
          if (messages && messages.length) {
            messages.forEach((message) => {
              this.$emit('alert', message);
            });
          }
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      showExplodedBomForCableTrayQuote(quoteNumber, exportKeySegment, title) {
        quoteNumber = quoteNumber || this.cachedParameters.quoteNumber;
        exportKeySegment = exportKeySegment || this.exportKeySegment;
        title = title || this.title;

        this.showExplodedBomPre();

        appHelpers.loader.start();
        apiClient.host.cableTrayQuote.listFullBOM(this.state.currentTenantId, quoteNumber, 10, null, this.ignoreLength).then((response) => {
          this.cachedParameters.quoteNumber = quoteNumber;
          this.cachedParameters.type = 'CableTrayQuote';
          this.showExplodedBomPost(response, exportKeySegment, title);
        }).catch(error => {
          let messages = appHelpers.message.getFromResponse(error);
          if (messages && messages.length) {
            messages.forEach((message) => {
              this.$emit('alert', message);
            });
          }
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      showExplodedBomForCableBusQuote(quoteNumber, exportKeySegment, title) {
        quoteNumber = quoteNumber || this.cachedParameters.quoteNumber;
        exportKeySegment = exportKeySegment || this.exportKeySegment;
        title = title || this.title;

        this.showExplodedBomPre();

        appHelpers.loader.start();
        apiClient.host.cableBusQuote.listFullBOM(this.state.currentTenantId, quoteNumber, 10, null, this.ignoreLength).then((response) => {
          this.cachedParameters.quoteNumber = quoteNumber;
          this.cachedParameters.type = 'CableBusQuote';
          this.showExplodedBomPost(response, exportKeySegment, title);
        }).catch(error => {
          let messages = appHelpers.message.getFromResponse(error);
          if (messages && messages.length) {
            messages.forEach((message) => {
              this.$emit('alert', message);
            });
          }
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
    }
  };
</script>